import { Empty } from "antd";
import React from 'react';
import LoadingBox from "../../../../../components/LoadingBox";
import { IPropsChildren } from "../../../../../util/varibles/interface";
import styles from './style.module.scss';

interface IProps extends IPropsChildren {
    colPerRow: number
    loading: boolean
    list: any
    className?: string
}

const Stores: React.FC<IProps> = (props) => {
    const { colPerRow, loading, list, className } = props;
    const style = { gridTemplateColumns: `repeat(${colPerRow},1fr)` };

    return <>
        <div className={[styles.list, className].join(' ')} style={style}>
            {loading ? <LoadingBox loading={true} className={styles.loading} /> : props.children}
        </div>
        {(!loading && list.length === 0) && <div className={styles['tab-empty']}>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </div>}
    </>;
}

export default Stores;